export function formatCartDrawerMoney(
  amount: number,
  currencyCode: string
): string {
  if (!Number.isFinite(amount) || amount < 0) return "—"
  const code = String(currencyCode ?? "").trim().toUpperCase()
  if (!/^[A-Z]{3}$/.test(code)) return "—"

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount)
  } catch {
    return "—"
  }
}
